import { z } from 'zod';

import { M, zRequiredString } from '@/business';

/**
 * Reassign sales / operations owner and change sales support. The reason is always required; the new owner is
 * required except when removing the sales support (empty value = no sales support).
 */
export const ownershipSchema = (opts: { allowNone: boolean }) =>
  z
    .object({ userId: z.string(), reason: zRequiredString() })
    .superRefine((v, ctx) => {
      if (!opts.allowNone && !v.userId) ctx.addIssue({ code: 'custom', path: ['userId'], message: M.required });
    });
export type OwnershipValues = z.infer<ReturnType<typeof ownershipSchema>>;

/** Bulk reassign from the deals list: who takes the deals and why. */
export const bulkReassignSchema = z.object({ userId: zRequiredString(), reason: zRequiredString() });
export type BulkReassignValues = z.infer<typeof bulkReassignSchema>;
